import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { BookPresentationSection } from './components/BookPresentationSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeFAQSection } from './components/GuaranteeFAQSection';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans text-gray-900 selection:bg-brand-wine selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TruthSection data-id="element-6" />
        <BookPresentationSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <TargetAudienceSection data-id="element-9" />
        <OfferSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <GuaranteeFAQSection data-id="element-12" />
      </main>

      <PurchasePopup data-id="element-13" />

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-14">
        <p data-id="element-15">
          © {new Date().getFullYear()} MERECES MÁS. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}